import * as Styled from './CompedTickets.styles';

import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { COMPED_FILTER_OPTIONS } from './constants';
import { CancelInviteModal } from './CancelInviteModal';
import { CompedTicketsHeader } from './CompedTicketsHeader';
import { CompedTicketsTable } from './CompedTicketsTable';
import { EventProps } from 'features/Home/components/Events/types';
import { IdParamsType } from 'utils/types';
import { MainLayout } from 'layouts/MainLayout';
import { ROUTES } from 'features/routes';
import { Search } from 'features/common/components/Search';
import { SendCompedTicketsModal } from './SendCompedTicketsModal';
import { getData } from 'services/api';
import { useDebounce } from 'utils/utils';
import { useCompedTicketsPage } from './hooks/useCompedTicketsPage';
import { useTranslation } from 'react-i18next';

export const CompedTickets = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const { id } = useParams<IdParamsType>();
	const [isUploadCsvOpen, setIsUploadCsvOpen] = useState(false);
	const {
		setSearchText,
		setSelectedPeriod,
		compedTicketsQueryObject,
		selectedPeriod,
		showCancelModal,
		closeCancelModal,
		openCancelModal,
		onCancelInvite,
	} = useCompedTicketsPage();
	const searchDebounce = useDebounce(setSearchText);

	const { data: event } = useQuery<EventProps>({
		queryKey: ['event', id],
		queryFn: () => getData(`events/${id}`),
		enabled: !!id && isUploadCsvOpen,
	});

	const subtitle = compedTicketsQueryObject?.data?.pages[0]?.data[0]?.events_name[0] ?? '';

	const onSendTicket = () => history.push(ROUTES.SEND_TICKETS.replace(':id', id));
	const onUploadCsv = () => setIsUploadCsvOpen(true);
	const closeUploadCsv = () => setIsUploadCsvOpen(false);

	return (
		<MainLayout>
			<CompedTicketsHeader subtitle={subtitle} />
			<Styled.FiltersContainer>
				<Search
					width="300px"
					onChange={(e) => searchDebounce(e.target.value)}
					placeholder={t('search-email-or-name')}
				/>
				<Styled.ButtonsContainer>
					<Styled.Filter
						onChange={(value) => setSelectedPeriod(value)}
						options={COMPED_FILTER_OPTIONS}
						selectedOption={selectedPeriod}
					/>
					<Styled.SendTicketsButton text={t('comped-tickets-send-tickets')} type="button" onClick={onSendTicket} />
					<Styled.SendTicketsButton text={t('comped-tickets-upload-csv')} type="button" onClick={onUploadCsv} />
				</Styled.ButtonsContainer>
			</Styled.FiltersContainer>

			<CompedTicketsTable compedTicketsQueryObject={compedTicketsQueryObject} openCancelModal={openCancelModal} />

			{showCancelModal.show && (
				<CancelInviteModal
					showModal={showCancelModal.show}
					closeModal={closeCancelModal}
					modalInfo={{
						modalTitle: t('comped-ticket-cancel-invite-modal-title'),
						modalMessage: t('comped-ticket-cancel-invite-modal-description'),
						onDelete: onCancelInvite,
					}}
				/>
			)}

			{isUploadCsvOpen && (
				<SendCompedTicketsModal ticketTypes={event?.ticket_types ?? []} closeModal={closeUploadCsv} />
			)}
		</MainLayout>
	);
};
